import { ApolloClient, gql } from '@apollo/client/core';
import * as AccountConfig from './AccountConfig';
import { Query } from '../../generated/graphql';

const ACCOUNT_CONFIG_QUERY = gql`
  query AccountConfig {
    app {
      accountConfig {
        id
        name
        features {
          name
          enabled
        }
      }
    }
  }
`;

export const fetchAccountConfig = async (client: ApolloClient<Query>) => {
  const { data } = await client.query({
    query: ACCOUNT_CONFIG_QUERY,
    fetchPolicy: 'network-only',
  });

  return AccountConfig.fromGql(data.app.accountConfig);
};
